import { Fragment, useCallback, useEffect, useState } from "react";
// import { useHistory } from "react-router-dom";
// import { ReCaptcha } from "react-recaptcha-google";
import { Modal, notification } from "antd";
import { FormProvider, useForm } from "react-hook-form";
// import moment from "moment";
// import Slider from "react-slick";
import styled from "styled-components";
import uniq from "lodash/uniq";

import navProcessImage from "assets/hm_service_image/Progesss detail.png";
import productImage from "assets/hm_service_image/product.png";
import BWInput from "components/shared/BWInput";
import {
  getDistrict,
  getStore,
  submitPreOrder,
  getProvince,
  getDeposit,
  loginSD,
} from "services/pre-order.service";
import BWSelect from "components/shared/BWSelect";
import {
  formatPrice,
  // isJson,
  mapDataOptions4Select,
  mapDataOptions5Select,
} from "utils/helpers";
import ModalVideo from "./ModalVideo";
import ErrorMessage from "components/shared/ErrorMessage";
// import { useApp } from "context/AppContext";
import {
  COLORS,
  PRODUCTS,
  // PRODUCTS_ACCESSORIES,
  VERSION,
  findProduct,
  // settingSlider,
} from "config/products";
import { DEPOSIT, META_CONFIG, REGEX_EMAIL, REGEX_PHONE_NUMBER, SDPassword, SDUserName } from "utils/contants";
import { useStore } from "store/useStore";
import useDeepMemo from "hook/useDeepMemo";
// import CONFIG from "config/config";
import clsx from "clsx";
import { useLocation } from "react-router-dom";
import LoadingV2 from "components/shared/LoadingV2";
import { sendPayoo } from "services/payment.service";
import { Helmet } from "react-helmet";
import ModalRegistration from "pages/ComingSoon/ModalRegistration";
import BlankLink from "components/shared/BlankLink";

const Wrapper = styled.div`
  .billing-address-form .inputs.two_col input[type="email"] {
    margin-left: 0px;
  }
  .recaptcha_container {
    margin-top: 10px;
  }
`;

const COLOR_URL_MAP = {
  black: "#272729",
  burgundy: "#4e2e34",
  glacier: "#aab6c8",
  silver: "#cfcfce"
};

const CAPACITY_URL_MAP = {
  "256gb": "256GB",
  "512gb": "512GB",
  "1tb": "1TB",
  "2tb": "2TB",
};

const ProductDetail = ({ modelId }) => {
  const location = useLocation();
  const initProductId = location?.state?.productId;
  const isDeposit = !!location?.state?.isDeposit || true;
  const [openRegistration, setOpenRegistration] = useState(false);
  const [regProductId, setRegProductId] = useState(null);

  // let history = useHistory();
  // let captchaRef = useRef(null);

  const preOrderForm = useStore((state) => state.preOrderForm);
  const setPreOrderForm = useStore((state) => state.setPreOrderForm);

  const [districts, setDistricts] = useState([]);
  const [provinces, setProvinces] = useState([]);
  const [stores, setStores] = useState([]);
  const [allStores, setAllStores] = useState([]);
  const [productSelect, setProductSelect] = useState(
    initProductId
      ? PRODUCTS.find((p) => p.productId === initProductId)
      : PRODUCTS.find((p) => p.modelId === modelId) || PRODUCTS[0]
  );
  const productList = PRODUCTS.filter((x) => x.modelId === modelId) || [];
  const storages = uniq(productList.map((product) => product.capacityKey)).map(
    (x) => ({ storage: x, name: x, capacityKey: x })
  );
  const colors = uniq(productList.map((prod) => prod.colorKey));

  const [openModal, setOpenModal] = useState(false);
  const [depositValue, setDepositValue] = useState(0);
  // const { connected, subscribe, payload } = useApp();
  // const [mqttProduct, setMQTTProduct] = useState([]);
  // const [isVerifyCaptcha, setIsVerifyCaptcha] = useState(false);
  // const [showErrorCaptcha, setShowErrorCaptcha] = useState(false);
  const methods = useForm();
  const isDeliveryType = +methods.watch("deliveryType") === 1;
  const [loadingSubmit, setLoadingSubmit] = useState(false);

  const {
    customerName: errorCustomerName,
    phoneNumber: errorPhoneNumber,
    email: errorEmail,
    policy: errorPolicy,
    addressDetail: errorAddressDetail,
  } = methods.formState.errors;

  // const productsAccessories =
  //   PRODUCTS_ACCESSORIES.find((p) => p.modelId === modelId)?.accessories ?? [];

  const loadDistrict = useCallback(() => {
    getDistrict({ provinceId: methods.watch("provinceId"), getAll: 1 }).then(
      (res) => setDistricts(res.data)
    );
  }, []);

  const loadProvince = () => {
    getProvince({ countryId: 6, getAll: 1 }).then((res) =>
      setProvinces(res.data)
    );
  };

  const loadStore = useCallback(() => {
    getStore({ districtId: methods.watch("districtId") }).then((res) =>
      setStores(res.data)
    );
  }, [stores]);

  const validateSubmit = useCallback(() => {
    if (!methods.watch("provinceId") || methods.watch("provinceId") === 0) {
      return methods.setError(`provinceId`, {
        type: "custom",
        message: "Tỉnh, Thành phố là bắt buộc",
      });
    }
    if (!methods.watch("districtId") || methods.watch("districtId") === 0) {
      return methods.setError(`districtId`, {
        type: "custom",
        message: "Quận, Huyện là bắt buộc",
      });
    }
    if (
      isDeliveryType &&
      (!methods.watch("receiveStoreId") ||
        methods.watch("receiveStoreId") === 0)
    ) {
      return methods.setError(`receiveStoreId`, {
        type: "custom",
        message: "Địa chỉ cửa hàng là bắt buộc",
      });
    }
    // if (!isVerifyCaptcha) return setShowErrorCaptcha(true);
    return true;
  });

  // useEffect(() => {
  //   if (connected) {
  //     let data = [];
  //     for (let index = 0; index < PRODUCTS.length; index++) {
  //       const element = PRODUCTS[index];
  //       subscribe(`totalinventory/${element.productId}`);
  //       data.push({
  //         topic: `totalinventory/${element.productId}`,
  //         productId: element.productId,
  //       });
  //     }
  //     setMQTTProduct(data);
  //   }
  // }, [connected]);

  // useEffect(() => {
  //   if (payload) {
  //     let index = mqttProduct.findIndex((x) => x.topic === payload.topic);
  //     if (index >= 0 && payload.message) {
  //       let data = [...mqttProduct];
  //       let _message = isJson(payload.message)
  //         ? JSON.parse(payload.message)
  //         : {};
  //       data[index] = { ...data[index], ..._message };
  //       setMQTTProduct(data);
  //     }
  //   }
  // }, [payload]);

  useEffect(() => {
    loadDistrict();
    loadProvince();
    loadStore();
    getStore({ pageSize: 10000 }).then((res) => {
      setAllStores(res.data);
    });
    const intiForm = {
      deliveryType: 1,
      ...preOrderForm,
    };
    intiForm.deliveryType = +intiForm.deliveryType;
    methods.reset(intiForm);
  }, []);

  useEffect(() => {
    loadDistrict();
  }, [methods.watch("provinceId")]);

  useEffect(() => {
    loadStore();
  }, [methods.watch("districtId")]);

  // useEffect(() => {
  //   getProductInfo({
  //     productId: productSelect.productId,
  //   }).then((res) => setProductDetail(res.data));
  // }, [productSelect]);

  const handleChangeProduct = (product) => {
    setProductSelect(findProduct({ ...product, modelId: modelId }));
  };

  //Lấy giá trị URL từ SHOPDUNK sang để set giá trụ default
  useEffect(() => {
    const url = window.location.href.toLowerCase();

    // Tìm color và capacity từ URL
    const colorKeyFromUrl = Object.keys(COLOR_URL_MAP).find((c) =>
      url.includes(c)
    );
    const capacityKeyFromUrl = Object.keys(CAPACITY_URL_MAP).find((c) =>
      url.includes(c)
    );

    const colorKey = colorKeyFromUrl ? COLOR_URL_MAP[colorKeyFromUrl] : null;
    const capacityKey = capacityKeyFromUrl
      ? CAPACITY_URL_MAP[capacityKeyFromUrl]
      : null;

    if (colorKey && capacityKey && modelId) {
      setProductSelect(findProduct({ modelId: modelId, colorKey: colorKey, capacityKey: capacityKey }));
    }
  }, [modelId]);

  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length); // Remove leading spaces
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  const onSubmitOrder = async (values, isOnline) => {
    try {
      setLoadingSubmit(true);
      let storeAddress = (stores || []).find(
        (x) => x.STOREID === +values.receiveStoreId
      );
      let districtAddress = (districts || []).find(
        (x) => x.DISTRICTID === +values.districtId
      );
      let provinceAddress = (provinces || []).find(
        (x) => x.PROVINCEID === +values.provinceId
      );

      const token = await loginSD({
        userId: 1,
        username: SDUserName,
        password: SDPassword
      });

      if (token?.access_token) {
        const trackingId = getCookie('_aff_sid');
        let res = await submitPreOrder({
          quantity: 1,
          paymentStatusType: 0,
          paymentType: isOnline ? 1 : 2,
          paymentFormId: 1,
          // ipAddress: ipAddress,
          createdUser: "administrator",
          orderTypeId: 30,
          fullName: values.customerName,
          ...values,
          isDuo: productSelect?.is_duo ? true : false,
          productId: productSelect.productId,
          totalAmount: 1,
          storeId: storeAddress?.STOREID,
          typeSource: 1,
          tracking_id: trackingId,
          addressDetail:
            values.addressDetail ||
            `${storeAddress?.ADDRESS}, ${districtAddress?.DISTRICTNAME}`,
          invoiceAddress: values.addressDetail
            ? `${values.addressDetail}, ${districtAddress?.DISTRICTNAME}, ${provinceAddress?.PROVINCENAME}`
            : "",
        }, token?.access_token);
        if (res?.status === 400) {
          notification.warning({ message: "Thông báo", description: res?.data });
          setLoadingSubmit(false);
        }
        //  else if (res?.status === 200 && productSelect?.is_duo === true) {
        //   Modal.success({
        //     icon: null,
        //     title: (
        //       <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        //         <span style={{ fontWeight: 700 }}>ĐẶT HÀNG KHÔNG THÀNH CÔNG</span>
        //       </div>
        //     ),
        //     closable: true,
        //     okText: "Đóng",
        //     maskStyle: { backgroundColor: "rgba(0,0,0,0.75)" },
        //     width: 500,
        //     content: (
        //       <div style={{ marginTop: 12 }}>
        //         <div style={{ alignItems: "center", marginTop: 8 }}>
        //           ShopDunk rất tiếc vì số lượng suất đặt cọc sản phẩm {' '}
        //           <strong>{productSelect.productName} {productSelect.capacityKey} {productSelect.colorName}</strong> {' '}
        //           hiện đã tạm hết. Quý khách vui lòng theo dõi thông tin cập nhật về sản phẩm {' '}
        //           <strong>{productSelect.productName}</strong> tại website {' '}
        //           <a href="https://shopdunk.com"
        //             target="_blank"
        //             rel="noopener noreferrer"
        //             style={{ color: 'blue' }}>
        //             ShopDunk.com
        //           </a>
        //         </div>
        //         <div className="content-success">
        //           <p>ShopDunk chân thành cảm ơn Quý khách đã quan tâm và thông cảm!</p>
        //         </div>
        //       </div>
        //     ),
        //     onOk: () => {
        //       // tuỳ logic, ví dụ reload lại trang hoặc redirect
        //       // window.location.reload();
        //       setLoadingSubmit(false)
        //     },
        //   });
        // } 
        else if (res?.status === 200) {
          sendPayoo({
            orderId: res?.data?.RESULT,
            amount: productSelect?.is_duo ? 30000000 : depositValue,
          }).then((res) => {
            if (res.data) {
              window.location.href = res.data;
            }
            if (res.httpStatusCode === 404 && res.success === false) {
              notification.error({ message: "Lỗi Thanh Toán!" });
              setLoadingSubmit(false);
            }
          }).catch((err) => {
            notification.error({ message: err?.message ?? "Lỗi Thanh Toán!" });
            setLoadingSubmit(false);
          });
        }
      } else {
        setLoadingSubmit(false);
        notification.error({ message: "Vui lòng thử lại." });
      }
    } catch (error) {
      notification.error({ message: error?.message ?? "Vui lòng thử lại." });
      setLoadingSubmit(false);
    }
  };

  // const product = useMemo(() => {
  //   const product = mqttProduct.find(
  //     (x) => x.productId === productSelect.productId && x.residual_amuont
  //   );
  //   if (product) {
  //     return product;
  //   }
  //   return productDetail;
  // }, [mqttProduct, productDetail]);

  const handleOpenRegistration = (productId) => {
    const overlay = document.getElementById("overlay");
    document.body.style.overflow = "hidden";
    overlay.style.display = "block";
    setOpenRegistration(true);
    setRegProductId(productId);
  };

  const handleCloseModal = () => {
    const overlay = document.getElementById("overlay");
    overlay.style.display = "none";
    document.body.style.overflow = "auto";
    setOpenRegistration(false);
  };

  useEffect(() => {
    getDeposit().then((value) => setDepositValue(value?.data ?? DEPOSIT));
  }, []);

  const persistData = useDeepMemo(() => methods.watch(), [methods.watch()]);
  useEffect(() => {
    setPreOrderForm(persistData);
  }, [persistData]);

  const deliveryType = +methods.watch("deliveryType");
  const storesByType =
    deliveryType === 2
      ? stores
      : stores?.filter((x) => x.STORETYPENAME === "ShopDunk");
  const storeOptionsByType = [
    { value: 0, label: "Chọn địa chỉ cửa hàng" },
    ...mapDataOptions5Select(storesByType, "STOREID", "ADDRESS"),
  ];

  const _allStores = allStores?.filter((x) => x.STORETYPENAME === "ShopDunk");
  const hasStoreDistrictIds = uniq(_allStores.map((x) => +x.DISTRICTID));
  const districtsByType =
    deliveryType === 2
      ? districts
      : (districts || []).filter((x) =>
        hasStoreDistrictIds.includes(+x.DISTRICTID)
      );

  const hasStoreProvinceIds = uniq(_allStores.map((x) => +x.PROVINCEID));
  const provincesByType =
    deliveryType === 2
      ? provinces
      : (provinces || []).filter((x) =>
        hasStoreProvinceIds.includes(+x.PROVINCEID)
      );

  const renderTime = () => {
    // if (productSelect?.is_ofs === true) {
    //   return <div className="sd_text_black_bold">Tạm hết hàng</div>;
    // } else {
    //   return <div className="sd_text_black_bold">Sẵn hàng</div>;
    // }
    // else {
    //   return (
    //     <div>
    //       <label>Thời gian giao hàng dự kiến: </label>
    //       <span style={{ marginRight: "5px" }}>Từ ngày 27-10-2024</span>
    //       đến<span style={{ marginLeft: "5px" }}>30-11-2024</span>
    //     </div>
    //   );
    // }
    // if (
    //   productSelect?.modelId === MODEL_KEY.IPHONE15 ||
    //   productSelect?.modelId === MODEL_KEY.IPHONE15PLUS
    // ) {
    //   return (
    //     <div>
    //       <label>Thời gian giao hàng dự kiến: </label>
    //       <span style={{ marginRight: "5px" }}>Từ ngày 29-09</span>
    //     </div>
    //   );
    // }

    // return (
    //   <div>
    //     <label>Thời gian giao hàng dự kiến: </label>
    //     <span style={{ marginRight: "5px" }}>
    //       {product?.expected_date
    //         ? moment(new Date(product?.expected_date)).format("DD-MM-YYYY")
    //         : moment().format("DD-MM-YYYY")}
    //     </span>
    //     đến
    //     <span style={{ marginLeft: "5px" }}>
    //       {product?.expected_date
    //         ? moment(new Date(product?.expected_date))
    //             .add(1, "months")
    //             .format("DD-MM-YYYY")
    //         : moment().format("29-10-2023")}
    //     </span>
    //   </div>
    // );
  };

  const path = window.location.pathname;
  const meta = META_CONFIG[path];

  return (
    <Wrapper className="page product-detail-page">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{meta?.title || "ShopDunk - iPhone"}</title>
        <meta
          name="description"
          content={meta?.description || "ShopDunk - Mua iPhone chính hãng giá tốt"}
        />
        {/* <meta name="keywords" content="iPhone 16, iPhone 16 series"></meta> */}
      </Helmet>
      <div className="page-body">
        <div className="nav-processing">
          <img
            className="image"
            src={navProcessImage}
            alt=""
            width="100%"
            height="80px"
          />
        </div>

        <div className="full content">
          <div className="product-content">
            <div className="detail-picture">
              <div className="picture">
                {/* Image Product */}
                <img
                  style={{ width: "100%", height: "100%" }}
                  src={productSelect?.imageUrl}
                  alt=""
                />
              </div>
              <div className="picture-thumbs">
                <img
                  src={productSelect?.thumbImage}
                  alt=""
                  style={{ width: "30%", height: "30%" }}
                />
                <img
                  src={productImage}
                  alt=""
                  onClick={() => setOpenModal(true)}
                />
              </div>
            </div>
            <div className="product-overview">
              <div className="product-name">{productSelect.productName}</div>
              <div className="product-price">
                <label>Chỉ từ:</label>
                <div className="new-price">
                  {formatPrice(productSelect.price, true)}
                </div>
              </div>

              <div className="attributes">
                {productSelect?.capacityKey && (
                  <div className="product_attribute_input stogre">
                    <label className="text-prompt">Chọn dung lượng:</label>
                    <ul className="option-list">
                      {storages.map((x, index) => (
                        <li
                          key={index}
                          onClick={() =>
                            handleChangeProduct({
                              ...productSelect,
                              capacityKey: x.capacityKey,
                            })
                          }
                        >
                          <label
                            className={clsx({
                              "checked-attr":
                                productSelect.capacityKey === x.capacityKey,
                            })}
                          >
                            {x.name}
                          </label>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {productSelect.versionKey && (
                  <div className="product_attribute_input stogre">
                    <label className="text-prompt">Chọn phiên bản: </label>
                    <ul className="option-list">
                      {VERSION.map((x, index) => (
                        <li
                          key={index}
                          onClick={() =>
                            handleChangeProduct({
                              ...productSelect,
                              versionKey: x.versionKey,
                            })
                          }
                        >
                          <label
                            className={clsx({
                              "checked-attr":
                                productSelect.versionKey === x.versionKey,
                            })}
                          >
                            {x.versionName}
                          </label>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                {productSelect.colorKey && (
                  <div className="product_attribute_input color">
                    <label className="text-prompt">
                      Chọn màu sắc:{" "}
                      <span className="label-value">
                        {
                          COLORS.find(
                            (x) => x.colorKey === productSelect.colorKey
                          )?.colorName
                        }
                      </span>
                    </label>
                    <ul className="option-list attribute-squares color-squares">
                      {colors.map((color, index) => (
                        <li
                          key={index}
                          className={clsx({
                            "selected-value": productSelect.colorKey === color,
                          })}
                          onClick={() =>
                            handleChangeProduct({
                              ...productSelect,
                              colorKey: color,
                            })
                          }
                        >
                          <label>
                            <span
                              className="attribute-square-container"
                              alt={color?.colorName}
                            >
                              {" "}
                              <span
                                className="attribute-square"
                                style={{ backgroundColor: color }}
                              ></span>
                            </span>
                          </label>
                        </li>
                      ))}
                    </ul>
                  </div>
                )}

                <div className="time-delivery">
                  {/* {moment().diff(moment(product?.expected_date), "days") > 0 &&
                    product?.residual_amount > 0 ? (
                    <span style={{ color: "green" }}>Sẵn hàng</span>
                  ) : ( */}
                  {renderTime()}
                  {/* )} */}
                </div>
              </div>
            </div>
          </div>

          <FormProvider {...methods}>
            <div className="billing-address-form">
              <h3>Thông tin của bạn</h3>
              <div className="inputs two_col">
                <div className="col-input">
                  <BWInput
                    type="text"
                    placeholder="Họ và tên (bắt buộc)"
                    field={"customerName"}
                    validation={{
                      required: "Họ và tên nhập là bắt buộc",
                    }}
                  />
                  {errorCustomerName && (
                    <span>{errorCustomerName.message}</span>
                  )}
                </div>
                <div className="col-input">
                  <BWInput
                    type="email"
                    placeholder={"Số điện thoại (bắt buộc)"}
                    field={"phoneNumber"}
                    validation={{
                      required: "Số điện thoại nhập là bắt buộc",
                      pattern: {
                        value: REGEX_PHONE_NUMBER,
                        message: "Số điện thoại không hợp lệ",
                      },
                    }}
                  />
                  {errorPhoneNumber && <span> {errorPhoneNumber.message}</span>}
                </div>
              </div>

              <div className="inputs">
                <BWInput
                  type="email"
                  placeholder="Email (Vui lòng điền email để nhận hoá đơn VAT)"
                  field={"email"}
                  validation={{
                    pattern: {
                      value: REGEX_EMAIL,
                      message: "Email không hợp lệ",
                    },
                  }}
                />
                {errorEmail && <ErrorMessage message={errorEmail.message} />}
              </div>
              <h3>Cách thức nhận hàng</h3>
              <div className="inputs one-col receive_method">
                <BWInput
                  type="radio"
                  valueRadio={1}
                  field={"deliveryType"}
                  name="receive"
                  id="receive_store"
                  onChange={(e) => {
                    methods.clearErrors("deliveryType");
                    methods.setValue("deliveryType", e.target.value);
                    methods.register("receiveStoreId", {
                      required: "Địa chỉ cửa hàng là bắt buộc",
                    });
                    methods.clearErrors("addressDetail");
                    methods.unregister("addressDetail");
                  }}
                />
                <label htmlFor="receive_store">Nhận tại cửa hàng</label>
                {/* <BWInput
                  type="radio"
                  valueRadio={2}
                  field={"deliveryType"}
                  name="receive"
                  id="receive_home"
                  onChange={(e) => {
                    methods.clearErrors("deliveryType");
                    methods.setValue("deliveryType", e.target.value);
                    methods.clearErrors("receiveStoreId");
                    methods.unregister("receiveStoreId");
                    methods.register("addressDetail", {
                      required: "Địa chỉ của khách hàng là bắt buộc",
                    });
                  }}
                /> */}

                {/* <label htmlFor="receive_home">Giao tận nơi</label> */}
              </div>
              {isDeliveryType ? (
                <div className="inputs three_col">
                  <span className={"b-three_col"}>
                    <BWSelect
                      list={[
                        {
                          value: 0,
                          label: "Chọn Tỉnh, Thành phố",
                        },
                        ...mapDataOptions4Select(
                          provincesByType,
                          "PROVINCEID",
                          "PROVINCENAME"
                        ),
                        ,
                      ]}
                      field="provinceId"
                      validation={{
                        required: "Tỉnh, thành phố là bắt buộc",
                      }}
                      onChange={(e) => {
                        methods.clearErrors("provinceId");
                        methods.setValue("provinceId", e.target.value);
                        methods.reset({
                          ...methods.getValues(),
                          districtId: 0,
                          receiveStoreId: 0,
                        });
                      }}
                    />
                  </span>
                  <span className={"b-three_col"}>
                    <BWSelect
                      list={[
                        { value: 0, label: "Chọn Quận, Huyện" },
                        ...mapDataOptions4Select(
                          districtsByType,
                          "DISTRICTID",
                          "DISTRICTNAME"
                        ),
                      ]}
                      disabled={!methods.watch("provinceId")}
                      field={"districtId"}
                      placeholder="Quận, Huyện"
                      validation={{
                        required: "Quận, huyện là bắt buộc",
                      }}
                      onChange={(e) => {
                        methods.clearErrors("districtId");
                        methods.setValue("districtId", e.target.value);
                        methods.reset({
                          ...methods.getValues(),
                          receiveStoreId: 0,
                        });
                      }}
                    />
                  </span>
                  <span className={"c-three_col"}>
                    <BWSelect
                      list={storeOptionsByType}
                      disabled={
                        !methods.watch("districtId") ||
                        !methods.watch("provinceId")
                      }
                      field={"receiveStoreId"}
                      validation={{
                        required: "Địa chỉ cửa hàng là bắt buộc",
                      }}
                    />
                  </span>
                </div>
              ) : (
                <>
                  <div className="inputs two_col">
                    <span className="col-input province">
                      <BWSelect
                        list={[
                          {
                            value: 0,
                            label: "Chọn Tỉnh, Thành phố",
                          },
                          ...mapDataOptions4Select(
                            provinces,
                            "PROVINCEID",
                            "PROVINCENAME"
                          ),
                        ]}
                        field={"provinceId"}
                        onChange={(e) => {
                          methods.clearErrors("provinceId");
                          methods.setValue("provinceId", e.target.value);
                          methods.setValue("districtId", 0);
                        }}
                        validation={{
                          required: "Tỉnh, Thành phố là bắt buộc",
                        }}
                      />
                    </span>
                    <span className="col-input">
                      <BWSelect
                        list={[
                          { value: 0, label: "Chọn Quận, Huyện" },
                          ...mapDataOptions4Select(
                            districts,
                            "DISTRICTID",
                            "DISTRICTNAME"
                          ),
                        ]}
                        disabled={!methods.watch("provinceId")}
                        field={"districtId"}
                        placeholder="Quận, Huyện"
                        className={"b-two_col"}
                        validation={{
                          required: "Quận, huyện là bắt buộc",
                        }}
                      />
                    </span>
                  </div>
                  <div className="inputs">
                    <BWInput
                      type="text"
                      placeholder={"Địa chỉ của khách hàng"}
                      field="addressDetail"
                      validation={{
                        required: "Địa chỉ của khách hàng là bắt buộc",
                      }}
                    />
                    {errorAddressDetail && (
                      <ErrorMessage message={errorAddressDetail?.message} />
                    )}
                  </div>
                </>
              )}

              <div className="inputs">
                <BWInput type="text" placeholder={"Ghi chú"} field={"note"} />
              </div>
              <div className="policy">
                <BWInput
                  type="checkbox"
                  field="policy"
                  validation={{
                    required: "Đồng ý điều khoản và điều kiện là bắt buộc",
                  }}
                  id="policy"
                />
                <label htmlFor="policy">
                  Bằng cách Click, bạn đồng ý với
                  <a
                    href={productSelect?.is_duo ? "https://shopdunk.com/dieu-khoan-dieu-kien-dat-coc-iphone-duo" : "https://shopdunk.com/dat-coc-dieu-khoan-dieu-kien"}
                    target="_blank"
                    rel="noreferrer"
                  >
                    {" "}
                    điều khoản và điều kiện
                  </a>{" "}
                  của ShopDunk
                </label>
              </div>
              {errorPolicy && <ErrorMessage message={errorPolicy?.message} />}
            </div>
            {/* <div className="recaptcha_container">
              <ReCaptcha
                ref={captchaRef}
                size="normal"
                hl="vi"
                render="explicit"
                verifyCallback={(res) => {
                  if (res) {
                    setShowErrorCaptcha(false);
                    setIsVerifyCaptcha(true);
                  }
                }}
                onloadCallback={() => {}}
                expiredCallback={() => {
                  setIsVerifyCaptcha(false);
                  captchaRef.current.reset();
                }}
                sitekey={CONFIG.RECAPTCHA_SITE_KEY}
              />
              {showErrorCaptcha && (
                <ErrorMessage message={"Vui lòng xác nhận recaptcha"} />
              )}
            </div> */}
            {productSelect?.is_dknt === true ?
              <div className="submit-content">
                <div
                  style={{ width: "100%", height: '61px' }}
                  className="submit-button"
                  onClick={() => handleOpenRegistration(productSelect?.productId)}
                >
                  <label>Đăng ký nhận tin</label>
                </div>
              </div>
              :
              <>
                {productSelect?.is_office === false ?
                  <div className="submit-content">
                    <div
                      style={{ width: "100%" }}
                      className="submit-button"
                      onClick={() => {
                        if (loadingSubmit) return;
                        const isValid = validateSubmit();
                        if (!isValid) return;
                        methods.handleSubmit((data) => onSubmitOrder(data, 1))();
                      }}
                    >
                      {isDeposit && (
                        <Fragment>
                          {!loadingSubmit && <label style={{ cursor: 'pointer' }}>Đặt hàng chờ</label>}
                          {loadingSubmit && <LoadingV2 />}
                          <span
                            style={{
                              width: "110%",
                            }}
                          >
                            (Đặt {formatPrice(productSelect?.is_duo ? 30000000 : depositValue, true)} - Thanh toán
                            online)
                          </span>
                        </Fragment>
                      )}
                      {!isDeposit && (
                        <Fragment>
                          {!loadingSubmit && <label>Mua ngay</label>}
                          {loadingSubmit && <LoadingV2 />}
                          <span
                            style={{
                              width: "110%",
                            }}
                          >
                            (Mua {formatPrice(productSelect.price, true)} - Thanh toán
                            online)
                          </span>
                        </Fragment>
                      )}
                    </div>
                  </div>
                  :
                  <div className="submit-content">
                    <div
                      style={{ width: "100%", height: '61px' }}
                      className="submit-button"
                      onClick={() => window.open(`https://shopdunk.com${productSelect?.path_office}`, "_blank")}
                    >
                      <Fragment>
                        <label>Mua ngay</label>
                      </Fragment>
                    </div>
                  </div>
                }
              </>
            }
          </FormProvider>
        </div>
        {/* {productsAccessories.length > 0 && (
          <div className="product-grid cross-sells">
            <h3 className="title">Gợi ý phụ kiện đi kèm</h3>
            <div className="item-grid">
              <Slider {...settingSlider}>
                {productsAccessories.map((item, index) => {
                  return (
                    <div key={`accesssories_${index}`} className="item-box">
                      <div className="product-item">
                        <div className="picture">
                          <a target="_blank" href={item.linkUrl}>
                            <img alt="" src={item.srcImg} title="" />
                          </a>
                        </div>
                        <div className="details">
                          <h2 className="product-title">
                            <a target="_blank" href={item.linkUrl}>
                              {item.accessoryName}
                            </a>
                          </h2>

                          <div className="add-info">
                            <div className="prices">
                              <span className="price old-price">
                                {formatPrice(item.old_price)}₫
                              </span>
                              <span className="price actual-price">
                                {formatPrice(item.actual_price)}₫
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </Slider>
            </div>
          </div>
        )} */}
      </div>
      <ModalVideo open={openModal} onClose={() => setOpenModal(false)} />
      <ModalRegistration
        open={openRegistration}
        onClose={() => handleCloseModal(false)}
        regProductId={regProductId}
      />
    </Wrapper>
  );
};

export default ProductDetail;
